import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, unref as _unref, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["data-bs-target"];
const _hoisted_2 = ["id"];
const _hoisted_3 = { class: "accordion-item" };
const _hoisted_4 = { class: "accordion-header" };
const _hoisted_5 = ["data-bs-target"];
const _hoisted_6 = ["id", "data-bs-parent"];
const _hoisted_7 = { class: "accordion-body" };
const _hoisted_8 = { class: "row mb-4" };
const _hoisted_9 = { class: "col-lg-6 col-12" };
const _hoisted_10 = ["onSubmit"];
const _hoisted_11 = { class: "form-check mb-3" };
const _hoisted_12 = ["id", "onUpdate:modelValue"];
const _hoisted_13 = ["for"];
const _hoisted_14 = { class: "form-floating mb-3" };
const _hoisted_15 = ["id", "onUpdate:modelValue"];
const _hoisted_16 = ["for"];
const _hoisted_17 = { class: "form-floating mb-3" };
const _hoisted_18 = ["id", "onUpdate:modelValue"];
const _hoisted_19 = ["for"];
const _hoisted_20 = { class: "input-group" };
const _hoisted_21 = { class: "form-floating" };
const _hoisted_22 = ["id", "onUpdate:modelValue"];
const _hoisted_23 = ["for"];
const _hoisted_24 = { class: "input-group" };
const _hoisted_25 = { class: "form-floating" };
const _hoisted_26 = ["id", "onUpdate:modelValue"];
const _hoisted_27 = ["for"];
const _hoisted_28 = { class: "form-floating mb-3" };
const _hoisted_29 = ["onInput", "id"];
const _hoisted_30 = ["for"];
const _hoisted_31 = { class: "form-check" };
const _hoisted_32 = ["id", "onUpdate:modelValue"];
const _hoisted_33 = ["for"];
const _hoisted_34 = { class: "form-check" };
const _hoisted_35 = ["id", "onUpdate:modelValue"];
const _hoisted_36 = ["for"];
const _hoisted_37 = { class: "form-floating mb-3" };
const _hoisted_38 = ["id", "onUpdate:modelValue"];
const _hoisted_39 = ["for"];
const _hoisted_40 = { class: "mb-3" };
const _hoisted_41 = ["for"];
const _hoisted_42 = { class: "mb-3" };
const _hoisted_43 = ["for"];
const _hoisted_44 = { class: "col-lg-6 col-12" };
const _hoisted_45 = { class: "mb-3" };
const _hoisted_46 = { class: "d-flex align-items-center justify-content-center" };
const _hoisted_47 = ["src"];
const _hoisted_48 = {
    key: 1,
    class: "spinner-border text-primary mt-5",
    role: "status"
};
const _hoisted_49 = ["onClick"];
const _hoisted_50 = { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" };
const _hoisted_51 = ["id", "aria-labelledby"];
const _hoisted_52 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_53 = { class: "modal-content" };
const _hoisted_54 = { class: "modal-header" };
const _hoisted_55 = ["id"];
const _hoisted_56 = { class: "modal-body" };
const _hoisted_57 = { class: "form-floating mb-3" };
const _hoisted_58 = { class: "input-group" };
const _hoisted_59 = { class: "form-floating" };
const _hoisted_60 = { class: "input-group" };
const _hoisted_61 = { class: "form-floating" };
const _hoisted_62 = { class: "form-floating mb-3" };
const _hoisted_63 = { class: "form-check" };
const _hoisted_64 = { class: "form-check" };
import { FilterMatchMode } from '@primevue/core/api';
import { router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
import ProductPriceOption from '@/Tenant/Components/ProductPriceOption.vue';
import { Modal } from 'bootstrap';
import TinyEditor from '@/Components/TinyEditor.vue';
import VariantComponentColors from './VariantComponentColors.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VariantComponents',
    props: {
        lidVariant: Object
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const emit = __emit;
        const componentKey = ref(Math.random().toString(36).substring(2, 15));
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const confirm = useConfirm();
        const createVariantComponentForm = useForm({
            name: null,
            description: null,
            configImgFrontFile: null,
            isOptional: false,
            showPreview: false,
            width: null,
            topDistance: null,
        });
        const variantComponents = ref(props.lidVariant?.lidVariantComponents ?? []);
        const loading = ref(true);
        const createVariantComponentModal = ref(null);
        onMounted(() => {
            const modalElement = document.getElementById('createVariantComponent' + componentKey);
            if (modalElement) {
                createVariantComponentModal.value = new Modal(modalElement);
            }
            setTimeout(() => {
                loading.value = false;
            }, 1000);
        });
        function create() {
            if (props.lidVariant == null) {
                return;
            }
            createVariantComponentForm.transform((data) => ({
                name: data.name,
                description: data.description,
                config_img_front_file: data.configImgFrontFile,
                is_optional: data.isOptional,
                show_preview: data.showPreview,
                width: data.width,
                top_distance: data.topDistance
            }))
                .submit('post', route('admin.lids.variants.components.store', props.lidVariant.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    createVariantComponentModal.value?.hide();
                    emit('update');
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function update(variantComponent) {
            router.post(route('admin.lids.variants.components.update', variantComponent.uuid), {
                name: variantComponent.name,
                name_en: variantComponent.nameEn,
                description: variantComponent.description,
                description_en: variantComponent.descriptionEn,
                config_img_front_file: variantComponent.configImgFrontFile,
                is_optional: variantComponent.isOptional,
                show_preview: variantComponent.showPreview,
                width: variantComponent.width,
                top_distance: variantComponent.topDistance,
                delivery_days: variantComponent.deliveryDays,
                active: variantComponent.active ? 1 : 0
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    emit('update');
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function remove(variantComponent) {
            confirm.require({
                message: 'Soll die Komponente wirklich gelöscht werden?',
                header: 'Komponente löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.lids.variants.components.destroy', variantComponent.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                            emit('update');
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[35] || (_cache[35] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Komponenten", -1)),
                _createElementVNode("button", {
                    class: "btn btn-secondary d-inline-flex align-items-center mb-4",
                    "data-bs-toggle": "modal",
                    "data-bs-target": '#createVariantComponent' + componentKey.value
                }, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            fill: "currentColor",
                            class: "bi bi-plus-lg",
                            viewBox: "0 0 16 16"
                        }, [
                            _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                            })
                        ], -1),
                        _createElementVNode("span", { class: "ms-2" }, "Neue Komponente", -1)
                    ]))], 8, _hoisted_1),
                _createElementVNode("div", {
                    class: "accordion accordion-flush",
                    id: 'variantComponents' + componentKey.value
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantComponents.value, (component) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("h2", _hoisted_4, [
                                _createElementVNode("button", {
                                    class: "accordion-button fs-5 fw-bold text-primary collapsed",
                                    type: "button",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": '#component' + component.uuid
                                }, _toDisplayString(component.name), 9, _hoisted_5)
                            ]),
                            _createElementVNode("div", {
                                id: 'component' + component.uuid,
                                class: "accordion-collapse collapse",
                                "data-bs-parent": 'variantComponents' + componentKey.value
                            }, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("form", {
                                                onSubmit: _withModifiers(($event) => (update(component)), ["prevent"])
                                            }, [
                                                _createElementVNode("div", _hoisted_11, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        value: "1",
                                                        id: 'active' + component.uuid,
                                                        "onUpdate:modelValue": ($event) => ((component.active) = $event)
                                                    }, null, 8, _hoisted_12), [
                                                        [_vModelCheckbox, component.active]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: 'active' + component.uuid
                                                    }, "Aktiv (Komponente kann konfiguriert werden)", 8, _hoisted_13)
                                                ]),
                                                _createElementVNode("div", _hoisted_14, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        id: 'componentName' + component.uuid,
                                                        "onUpdate:modelValue": ($event) => ((component.name) = $event),
                                                        required: ""
                                                    }, null, 8, _hoisted_15), [
                                                        [_vModelText, component.name]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        for: 'componentName' + component.uuid
                                                    }, "Name", 8, _hoisted_16)
                                                ]),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        id: 'componentNameEn' + component.uuid,
                                                        "onUpdate:modelValue": ($event) => ((component.nameEn) = $event),
                                                        required: ""
                                                    }, null, 8, _hoisted_18), [
                                                        [_vModelText, component.nameEn]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        for: 'componentNameEn' + component.uuid
                                                    }, "Name (en)", 8, _hoisted_19)
                                                ]),
                                                _createElementVNode("div", _hoisted_20, [
                                                    _createElementVNode("div", _hoisted_21, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            id: 'componentWidth' + component.uuid,
                                                            class: "form-control",
                                                            min: "0",
                                                            step: "0.1",
                                                            "onUpdate:modelValue": ($event) => ((component.width) = $event)
                                                        }, null, 8, _hoisted_22), [
                                                            [_vModelText, component.width]
                                                        ]),
                                                        _createElementVNode("label", {
                                                            for: 'componentWidth' + component.uuid
                                                        }, "Breite", 8, _hoisted_23)
                                                    ]),
                                                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                                ]),
                                                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "form-text mb-3" }, "Breite des Verschlusses ohne Toleranz.", -1)),
                                                _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("div", _hoisted_25, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            id: 'componentTopDistance' + component.uuid,
                                                            class: "form-control",
                                                            step: "0.1",
                                                            "onUpdate:modelValue": ($event) => ((component.topDistance) = $event)
                                                        }, null, 8, _hoisted_26), [
                                                            [_vModelText, component.topDistance]
                                                        ]),
                                                        _createElementVNode("label", {
                                                            for: 'componentTopDistance' + component.uuid
                                                        }, "Abstand des untersten Punktes des Verschlusses zum höchsten Punkt der Flasche", 8, _hoisted_27)
                                                    ]),
                                                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                                ]),
                                                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "form-text mb-3" }, "Optional, wird zur exakten Platzierung in der Vorschau des Konfigurators benötigt.", -1)),
                                                _createElementVNode("div", _hoisted_28, [
                                                    _createElementVNode("input", {
                                                        type: "file",
                                                        onInput: ($event) => (component.configImgFrontFile = $event.target.files[0]),
                                                        class: "form-control",
                                                        id: 'componentConfigImgFrontFile' + component.uuid
                                                    }, null, 40, _hoisted_29),
                                                    _createElementVNode("label", {
                                                        for: 'componentConfigImgFrontFile' + component.uuid
                                                    }, "Konfigurations-Datei", 8, _hoisted_30)
                                                ]),
                                                _createElementVNode("div", _hoisted_31, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        value: "1",
                                                        id: 'componentIsOptional' + component.uuid,
                                                        "onUpdate:modelValue": ($event) => ((component.isOptional) = $event)
                                                    }, null, 8, _hoisted_32), [
                                                        [_vModelCheckbox, component.isOptional]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: 'componentIsOptional' + component.uuid
                                                    }, "Optional", 8, _hoisted_33)
                                                ]),
                                                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "form-text mb-3" }, "Komponente kann im Konfigurator an/abgewählt werden. Optionaler Bestandteil des Verschlusses.", -1)),
                                                _createElementVNode("div", _hoisted_34, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        value: "1",
                                                        id: 'componentShowPreview' + component.uuid,
                                                        "onUpdate:modelValue": ($event) => ((component.showPreview) = $event)
                                                    }, null, 8, _hoisted_35), [
                                                        [_vModelCheckbox, component.showPreview]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: 'componentShowPreview' + component.uuid
                                                    }, "In Vorschau anzeigen", 8, _hoisted_36)
                                                ]),
                                                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "form-text mb-3" }, "Komponente wird im Konfigurator in der Vorschau angezeigt. ", -1)),
                                                _createElementVNode("div", _hoisted_37, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        class: "form-control",
                                                        id: 'deliveryDays' + component.uuid,
                                                        "onUpdate:modelValue": ($event) => ((component.deliveryDays) = $event),
                                                        min: "1",
                                                        step: "1"
                                                    }, null, 8, _hoisted_38), [
                                                        [_vModelText, component.deliveryDays]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        for: 'deliveryDays' + component.uuid
                                                    }, "Lieferzeit in Tagen", 8, _hoisted_39)
                                                ]),
                                                _createElementVNode("div", _hoisted_40, [
                                                    _createElementVNode("label", {
                                                        for: 'componentDescription' + component.uuid,
                                                        class: "mb-2"
                                                    }, "Beschreibung", 8, _hoisted_41),
                                                    _createVNode(TinyEditor, {
                                                        id: 'componentDescription' + component.uuid,
                                                        modelValue: component.description,
                                                        "onUpdate:modelValue": ($event) => ((component.description) = $event),
                                                        height: 300
                                                    }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
                                                ]),
                                                _createElementVNode("div", _hoisted_42, [
                                                    _createElementVNode("label", {
                                                        for: 'componentDescriptionEn' + component.uuid,
                                                        class: "mb-2"
                                                    }, "Beschreibung (en)", 8, _hoisted_43),
                                                    _createVNode(TinyEditor, {
                                                        id: 'componentDescriptionEn' + component.uuid,
                                                        modelValue: component.descriptionEn,
                                                        "onUpdate:modelValue": ($event) => ((component.descriptionEn) = $event),
                                                        height: 300
                                                    }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
                                                ]),
                                                _cache[15] || (_cache[15] = _createElementVNode("button", {
                                                    type: "submit",
                                                    class: "btn btn-success d-inline-flex align-items-center"
                                                }, [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ]),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                                ], -1))
                                            ], 40, _hoisted_10)
                                        ]),
                                        _createElementVNode("div", _hoisted_44, [
                                            _createElementVNode("div", _hoisted_45, [
                                                _cache[17] || (_cache[17] = _createElementVNode("h4", { class: "bg-primary text-white px-3 py-2 mb-4" }, "Konfigurations-Bild", -1)),
                                                _createElementVNode("div", _hoisted_46, [
                                                    (!loading.value)
                                                        ? (_openBlock(), _createElementBlock("img", {
                                                            key: 0,
                                                            src: component.configImgFrontFileUrl,
                                                            alt: "Konfigurations-Bild",
                                                            style: { "height": "100px", "max-width": "100%" }
                                                        }, null, 8, _hoisted_47))
                                                        : _createCommentVNode("", true),
                                                    (loading.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [...(_cache[16] || (_cache[16] = [
                                                                _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                                                            ]))]))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]),
                                            _createElementVNode("div", null, [
                                                _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "bg-primary text-white px-3 py-2 mb-4" }, "Einfärbungen", -1)),
                                                _createVNode(VariantComponentColors, { lidVariantComponent: component }, null, 8, ["lidVariantComponent"])
                                            ])
                                        ])
                                    ]),
                                    (component.canRemove)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn btn-danger d-inline-flex align-items-center my-3",
                                            onClick: ($event) => (remove(component))
                                        }, [...(_cache[19] || (_cache[19] = [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-x-circle",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                    _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                ], -1),
                                                _createElementVNode("span", { class: "ms-2" }, "Komponente löschen", -1)
                                            ]))], 8, _hoisted_49))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("h3", _hoisted_50, _toDisplayString(component.name) + " - Preise", 1),
                                        _createVNode(ProductPriceOption, {
                                            lidVariantComponent: component,
                                            priceBundleUuid: component.priceBundleUuid
                                        }, null, 8, ["lidVariantComponent", "priceBundleUuid"])
                                    ])
                                ])
                            ], 8, _hoisted_6)
                        ]));
                    }), 256))
                ], 8, _hoisted_2),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", {
                        class: "modal fade",
                        id: 'createVariantComponent' + componentKey.value,
                        tabindex: "-1",
                        "aria-labelledby": 'createVariantComponentModalLabel' + componentKey.value,
                        "aria-hidden": "true"
                    }, [
                        _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: 'createVariantComponentModalLabel' + componentKey.value
                                    }, " Neue Komponente", 8, _hoisted_55),
                                    _cache[20] || (_cache[20] = _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    }, null, -1))
                                ]),
                                _createElementVNode("form", {
                                    onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event) => (create()), ["prevent"]))
                                }, [
                                    _createElementVNode("div", _hoisted_56, [
                                        _createElementVNode("div", _hoisted_57, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "newComponentName",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(createVariantComponentForm).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createVariantComponentForm).name]
                                            ]),
                                            _cache[21] || (_cache[21] = _createElementVNode("label", { for: "newComponentName" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("div", _hoisted_59, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    id: "newComponentWidth",
                                                    class: "form-control",
                                                    min: "0",
                                                    step: "0.01",
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(createVariantComponentForm).width) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(createVariantComponentForm).width]
                                                ]),
                                                _cache[22] || (_cache[22] = _createElementVNode("label", { for: "newComponentWidth" }, "Breite", -1))
                                            ]),
                                            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                        ]),
                                        _cache[30] || (_cache[30] = _createElementVNode("p", { class: "form-text mb-3" }, "Breite des Verschlusses ohne Toleranz.", -1)),
                                        _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("div", _hoisted_61, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    id: "newComponentTopDistance",
                                                    class: "form-control",
                                                    step: "0.01",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(createVariantComponentForm).topDistance) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(createVariantComponentForm).topDistance]
                                                ]),
                                                _cache[24] || (_cache[24] = _createElementVNode("label", { for: "newComponentTopDistance" }, "Abstand des untersten Punktes des Verschlusses zum höchsten Punkt der Flasche", -1))
                                            ]),
                                            _cache[25] || (_cache[25] = _createElementVNode("span", { class: "input-group-text" }, "mm", -1))
                                        ]),
                                        _cache[31] || (_cache[31] = _createElementVNode("p", { class: "form-text mb-3" }, "Optional, wird zur exakten Platzierung in der Vorschau des Konfigurators benötigt.", -1)),
                                        _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("input", {
                                                type: "file",
                                                onInput: _cache[3] || (_cache[3] = ($event) => (_unref(createVariantComponentForm).configImgFrontFile = $event.target.files[0])),
                                                class: "form-control",
                                                id: "newComponentConfigImgFrontFile",
                                                required: ""
                                            }, null, 32),
                                            _cache[26] || (_cache[26] = _createElementVNode("label", { for: "newComponentConfigImgFrontFile" }, "Konfigurations-Datei", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_63, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "newComponentIsOptional",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(createVariantComponentForm).isOptional) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(createVariantComponentForm).isOptional]
                                            ]),
                                            _cache[27] || (_cache[27] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "newComponentIsOptional"
                                            }, "Optional", -1))
                                        ]),
                                        _cache[32] || (_cache[32] = _createElementVNode("p", { class: "form-text mb-3" }, "Komponente kann im Konfigurator an/abgewählt werden. Optionaler Bestandteil des Verschlusses.", -1)),
                                        _createElementVNode("div", _hoisted_64, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "newComponentShowPreview",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(createVariantComponentForm).showPreview) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(createVariantComponentForm).showPreview]
                                            ]),
                                            _cache[28] || (_cache[28] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "newComponentShowPreview"
                                            }, "In Vorschau anzeigen", -1))
                                        ]),
                                        _cache[33] || (_cache[33] = _createElementVNode("p", { class: "form-text mb-3" }, "Komponente wird im Konfigurator in der Vorschau angezeigt.", -1)),
                                        _createElementVNode("div", null, [
                                            _cache[29] || (_cache[29] = _createElementVNode("label", {
                                                for: "newComponentDescription",
                                                class: "mb-2"
                                            }, "Beschreibung", -1)),
                                            _createVNode(TinyEditor, {
                                                id: "newComponentDescription",
                                                modelValue: _unref(createVariantComponentForm).description,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(createVariantComponentForm).description) = $event)),
                                                height: 300
                                            }, null, 8, ["modelValue"])
                                        ])
                                    ]),
                                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ], 8, _hoisted_51)
                ]))
            ], 64));
        };
    }
});
